module.exports = "/images/cooper-9.jpg";